import {
  useEffect,
  useRef,
  useState,
} from 'react';

import {
  doc,
  getDoc,
  increment,
  updateDoc,
} from 'firebase/firestore';

import { db } from '../firebase';
import { claimAnalyticsAction, trackEvent } from '../amplitude';

const useNewsViews = (news) => {
  const [views, setViews] =
    useState(0);

  const trackedNewsIdRef =
    useRef(null);

  useEffect(() => {
    setViews(news?.views || 0);
  }, [news?.id, news?.views]);

  useEffect(() => {
    if (!news) {
      return;
    }

    if (trackedNewsIdRef.current === news.id) {
      return;
    }

    trackedNewsIdRef.current = news.id;
    if (!claimAnalyticsAction(`news_view:${news.id}`)) return;

    const registerView = async () => {
      try {
        trackEvent('news_view', {
          news_id: news.id,
          category: news.category,
          sections: Array.isArray(news.sections)
            ? news.sections
            : [news.section].filter(Boolean),
          author_id: news.authorId || null,
          published_date:
            `${news.day}.${news.month}.${news.year}`,
        });

        const newsReference = doc(
          db,
          'news',
          news.id
        );

        await updateDoc(
          newsReference,
          {
            views: increment(1),
          }
        );

        const updatedSnapshot =
          await getDoc(newsReference);

        if (
          updatedSnapshot.exists()
        ) {
          setViews(
            updatedSnapshot.data()
              .views || 1
          );
        }
      } catch (error) {
        console.error(
          'Помилка при оновленні переглядів:',
          error
        );
      }
    };

    registerView();
  }, [news]);

  return views;
};

export default useNewsViews;
